
export default {
    name: 'GlobalPosition',
    props: {
        name: String,
        positions: Array,
        type: String
    },
    methods: {
        formatTypes(type) {
            let result = '';
            switch (type) {
                case 'Aktie':
                    result = this.$t('component.portfolio.position.globalPosition.types.stock')
                    break;
                case 'Anleihe':
                    result = this.$t('component.portfolio.position.globalPosition.types.bond')
                    break;
                case 'ADR':
                    result = this.$t('component.portfolio.position.globalPosition.types.adr')
                    break;
                case 'ETF':
                    result = this.$t('component.portfolio.position.globalPosition.types.etf')
                    break;
                case 'Zertifikat':
                    result = this.$t('component.portfolio.position.globalPosition.types.certificate')
                    break;
                case 'ETC':
                    result = this.$t('component.portfolio.position.globalPosition.types.etc')
                    break;
                case 'ETN':
                    result = this.$t('component.portfolio.position.globalPosition.types.etn')
                    break;
                case 'Verbriefte Derivate':
                    result = this.$t('component.portfolio.position.globalPosition.types.structuredDerivatives')
                    break;
                case 'Strukturierte Finanzprodukte':
                    result = this.$t('component.portfolio.position.globalPosition.types.structuredFinancialProducts')
                    break;
                case 'Sonstiges':
                    result = this.$t('component.portfolio.position.globalPosition.types.other')
                    break;
                case 'Bezugsrecht':
                    result = this.$t('component.portfolio.position.globalPosition.types.subscriptionRight')
                    break;
                case 'Währung':
                    result = this.$t('component.portfolio.position.globalPosition.types.currency')
                    break;
                case 'Crypto':
                    result = this.$t('component.portfolio.position.globalPosition.types.crypto')
                    break;
                case 'Index':
                    result = this.$t('component.portfolio.position.globalPosition.types.index')
                    break;
                case 'Portfolio':
                    result = this.$t('component.portfolio.position.globalPosition.types.portfolio')
                    break;
                case 'Unbekannt':
                    result = this.$t('component.portfolio.position.globalPosition.types.unknown')
                    break;
                default:
                    result = type
                    break;
            }
            return result;
        },
        handleClickRow(portfolioId) {
            if (!portfolioId) {
                return
            }
            this.$router.push({
                    name: this.$getTranslatedRouteName('finance-portfolio-portfolio_id-tab_id'),
                    params: {
                        portfolio_id: portfolioId.toString(),
                        tab_id: this.$getTranslatedTabId('stocks'),
                    }
                })
        }
    },
    computed: {
        headers() {
            return [
                {
                    text: this.$t('component.portfolio.position.globalPosition.headers.portfolio'),
                    value: 'name',
                    width: '50%',
                },
                {
                    text: ['anleihe', 'fonds'].includes(this.type.toLowerCase())
                        ? this.$t('component.portfolio.position.globalPosition.headers.nominal')
                        : this.$t('component.portfolio.position.globalPosition.headers.quantity'),
                    value: 'qty',
                    sortable: false,
                }
            ]
        },
        isPrivacyEnabled() {
            return this.$store.state.preferences.isPrivacyEnabled
        },
        isSandboxMode() {
            return this.$store.state.preferences.isSandboxMode;
        },
    },
}
